import { useState } from 'react';
import {
  Box,
  Button,
  Divider,
  IconButton,
  Paper,
  Typography,
} from '@mui/material';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import PaymentsOutlinedIcon from '@mui/icons-material/PaymentsOutlined';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import CreditCardOutlinedIcon from '@mui/icons-material/CreditCardOutlined';
import { useLocation, useNavigate } from 'react-router';
import { paymentGroups } from './checkoutData';
import '../Customer/CustomerScreens.scss';

const iconMap = {
  cash: <PaymentsOutlinedIcon fontSize='small' />,
  wallet: <AccountBalanceWalletOutlinedIcon fontSize='small' />,
  card: <CreditCardOutlinedIcon fontSize='small' />,
  paypal: <Typography sx={{ fontWeight: 800, color: '#0a58ca' }}>P</Typography>,
  'apple-pay': <Typography sx={{ fontWeight: 800 }}>A</Typography>,
  'google-pay': <Typography sx={{ fontWeight: 800, color: '#4285f4' }}>G</Typography>,
};

export default function PaymentMethods() {
  const navigate = useNavigate();
  const location = useLocation();
  const [selectedMethod, setSelectedMethod] = useState('cash');

  const handleConfirmPayment = () => {
    const nextState = {
      ...location.state,
      paymentMethod: selectedMethod,
    };

    if (location.state?.paymentStatus === 'failed' || location.state?.paymentFailed) {
      navigate('/checkout/payment-failure', { state: nextState });
      return;
    }

    navigate('/checkout/payment-success', { state: nextState });
  };

  return (
    <Box className='customer-screen'>
      <Box className='customer-shell'>
        <Box className='customer-topbar'>
          <IconButton className='customer-iconButton' onClick={() => navigate(-1)}>
            <ArrowBackRoundedIcon />
          </IconButton>
          <Typography className='customer-topbarTitle'>Payment Methods</Typography>
          <Box sx={{ width: 46 }} />
        </Box>

        {paymentGroups.map((group) => (
          <Box key={group.title} className='checkout-paymentGroup'>
            <Typography className='checkout-groupTitle'>{group.title}</Typography>
            <Paper className='customer-card checkout-paymentCard'>
              {group.items.map((item, index) => {
                const isActive = item.id === selectedMethod;

                return (
                  <Box key={item.id}>
                    <Box
                      className='checkout-optionRow'
                      component='button'
                      onClick={() => !item.hasArrow && setSelectedMethod(item.id)}
                      sx={{ border: 0, width: '100%', background: 'transparent', cursor: 'pointer' }}
                    >
                      <Box className='checkout-optionMain'>
                        <Box className='customer-menuIcon'>{iconMap[item.id]}</Box>
                        <Typography sx={{ fontWeight: 700 }}>{item.label}</Typography>
                      </Box>
                      {item.hasArrow ? (
                        <ChevronRightRoundedIcon sx={{ color: '#ff5c67' }} />
                      ) : (
                        <Box
                          className={`checkout-radio${isActive ? ' checkout-radio--active' : ''}`}
                        />
                      )}
                    </Box>
                    {index < group.items.length - 1 ? <Divider /> : null}
                  </Box>
                );
              })}
            </Paper>
          </Box>
        ))}

        <Paper className='checkout-stickyFooter'>
          <Button
            className='customer-actionButton customer-actionButton--primary'
            fullWidth
            onClick={handleConfirmPayment}
          >
            Confirm Payment
          </Button>
        </Paper>
      </Box>
    </Box>
  );
}
